import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'logo',
  templateUrl: 'logo.component.html',
  styleUrls: ['logo.component.scss']
})
export class LogoComponent {

}


// WEBPACK FOOTER //
// ./src/app/Dashboard/logo/logo.component.ts